import React from "react"
import { createPerformanceTableTool } from "@/editor/createPerformanceTableTool"

export const SmallPerformanceByLpEntityTableTool = createPerformanceTableTool({
  type: "small_performance_by_lp_entity_tool",
  headerText: "Performance by LP Entity",
  columnHeader: "LP Entity",
  dataProperty: "lp_entity",
  toolboxTitle: "LP Entity Performance Table",
})
